import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ComentariosNoLeidosResponse } from '../../compartidos/DTOs/ComentariosNoLeidosResponse';
import { NotificacionesAlarmasResponse } from '../../compartidos/DTOs/NotificacionesAlarmasResponse';

@Injectable({
  providedIn: 'root'
})
export class NotificacionesService {

  private srvHttp = inject(HttpClient);
  private readonly baseUrl = environment.apiURL;

  // Las notificaciones se acotan al cliente seleccionado.
  // El backend revalida iIdCliente contra Usuarios_Clientes: mandarlo desde
  // Angular acota la vista, no otorga acceso.

  getComentariosNoLeidos(iIdUsuario: number, iIdCliente: number | null) {
    const endpoint = `${this.baseUrl}/action/getComentariosNoLeidos`;
    return this.srvHttp.post<ComentariosNoLeidosResponse>(endpoint, { iIdUsuario, iIdCliente });
  }

  marcarComentariosVistos(comentarios: number[], iIdUsuario: number, iIdCliente: number | null) {
    const endpoint = `${this.baseUrl}/action/marcarComentariosVistos`;
    return this.srvHttp.post<{ success: boolean }>(endpoint, { comentarios, iIdUsuario, iIdCliente });
  }

  getNotificacionesAlarmas(iIdUsuario: number, iIdCliente: number | null) {
    const endpoint = `${this.baseUrl}/action/getNotificacionesAlarmas`;
    return this.srvHttp.post<NotificacionesAlarmasResponse>(endpoint, { iIdUsuario, iIdCliente });
  }

  marcarNotificacionVista(iIdNotificacion: number, iIdUsuario: number, iIdCliente: number | null) {
    const endpoint = `${this.baseUrl}/action/marcarNotificacionVista`;
    return this.srvHttp.post<{ success: boolean }>(
      endpoint,
      { iIdNotificacion, iIdUsuario, iIdCliente }
    );
  }
}
